export default __webpack_public_path__ + "static/media/angbao-bonus_dewali.458a6e61.webp";